import {documents, questions} from './utils'
import {Container, QuestionContainer, Content   } from './styles';
import ReactSelect, { OptionsType } from "react-select";
import { customSelect } from "../../../misc/customStyle-ReactSelect";
import { useRef } from 'react';
import {IQuestion} from './utils'
import api from '../../../services/api';
import { notify } from '../../../components/Toast';


const documentsOptions = documents.map(doc => ({label: doc.name, value: doc.id}))

interface IQuestionsAndLinkedDocs{
	[key: string]: /* identificador da pergunta*/ OptionsType<{ label: string; value: number; }> /* array dos ids dos documentos */
}

export const LinkQuestions = () => {
	const questionsAndLinkedDocs= useRef<IQuestionsAndLinkedDocs>({})


	const handleChange = (question: IQuestion, selectedOptions: OptionsType<{ label: string; value: number; }> ) => {
		// setValue(data);
		if(question.field){
			questionsAndLinkedDocs.current[question.field] = selectedOptions;
		}

		if (question.fields){
			question.fields.forEach(field => {
				questionsAndLinkedDocs.current[field] = selectedOptions;
			})
		}

	}

	const handleSend = () => {
		const data = questionsAndLinkedDocs.current
		console.log(data)

		if (Object.values(data).length < 75){

			return notify({message: 'Há campos pendente da seleção de documentos', type: 'error'})
		}

		let hasEmptyField = false;
		Object.values(data).map(val => {
			if (val.length === 0) {
				hasEmptyField = true;
			}
		})

		if (hasEmptyField){
			return notify({message: 'Há campos pendente da seleção de documentos', type: 'error'})
		}

		console.log('PREENCHEU TODOS OS CAMPOS')

		const transformedData: any = {}

		Object.keys(data).forEach(key => {
			data[key].map(docOpt => {
				if (!transformedData[key]){
					transformedData[key] = [docOpt.value];
				}else{
					transformedData[key].push(docOpt.value);
				}
			})
		})
//  Então eu vou fazer a rota aqui e dale.
		api.post('/data/documents/link', { data: transformedData })
		console.log()
	}

	return (
	<Container>
		<h2>Linkar documentos nas questões</h2>
		<Content>

		{questions.map(question => {
			return (
				<QuestionContainer>
					<p>{question.label}</p>
					<ReactSelect isMulti styles = {customSelect} options = {documentsOptions}  onChange= {(opts) => handleChange(question, opts)}  />
				</QuestionContainer>
			)
		})}

			<button onClick = {handleSend}>Enviar</button>
		</Content>
	</Container>
	)
}